import React from "react";
import t from "../../../helpers/t";
import Biscuit from "../../../../utils/Biscuit";

const NewAbonnementButton = (props: any) => {
  const onButtonClicked = (e: any) => {
    props.onClicked(e);
  };
  const currentUrl = new URL(window.location.href);
  return (
    <>
      <a
        href={"abonnements/add" + currentUrl.search}
        id="inb-c-left-bar-add-contingent"
        className={"button beautify beautify-" + Biscuit.get("user.client_id")}
      >
        <i className="fi fi-page-add"></i>
        <span>{t("add_${a}", { a: t("abonnement", null, "capital") })}</span>
      </a>
    </>
  );
};
export default NewAbonnementButton;
